import { ProjectStateAsString } from 'controllers/Project/ProjectStateMachine'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { CSSProperties, useCallback, useEffect, useMemo, useState } from 'react'
import { useAppSelector } from 'store/configureStore'
import { useRequestedProjectState } from './useRequestedProjectState'
import { imnooEstimationSummarySelector } from 'features/BillOfMaterials/store/selectors/imnooEstimationSelectors'
import { useTranslation } from 'react-i18next'

const errors = []

export const useQuoteProjectState = () => {
  const { unresolved: imnooUnresolvedCount } = useAppSelector(
    imnooEstimationSummarySelector,
  )
  const { t } = useTranslation()
  const {
    canChangeToRequestState,
    // Errors: RequestedErrors,
    // errorCount: requestedErrorsCount,
  } = useRequestedProjectState()
  const currentProjectStatus = useAppSelector(
    projectSelectors.projectStatusSelector,
  )
  const isBuyerView = useAppSelector(
    projectSelectors.projectInBuyerViewSelector,
  )

  const [errorCount, setErrorCount] = useState(0)

  const canChangeToQuoteState =
    canChangeToRequestState &&
    imnooUnresolvedCount === 0 &&
    currentProjectStatus !== ProjectStateAsString.QUOTED

  /**
   * if the current state is quoted, a salesperson can change to negotiating
   */
  const canChangeToNegotiatingState = useMemo(() => {
    if (currentProjectStatus === ProjectStateAsString.QUOTED && !isBuyerView) {
      return true
    }

    return false
  }, [currentProjectStatus, isBuyerView])

  useEffect(() => {
    setErrorCount(imnooUnresolvedCount > 0 ? 1 : 0)
  }, [canChangeToQuoteState, imnooUnresolvedCount])

  const Errors = useCallback(() => {
    return (
      <>
        {/* <RequestedErrors /> */}
        {imnooUnresolvedCount > 0 && (
          <ul>
            <li>
              {t('project:imnoo-estimates-incomplete', {
                defaultValue:
                  'Imnoo estimates are incomplete for {{count}} parts. Wait, retry failed estimates, or enter complete manual estimates.',
                count: imnooUnresolvedCount,
              })}
            </li>
          </ul>
        )}
        {!!errors.length && <ul>{errors}</ul>}
      </>
    )
  }, [imnooUnresolvedCount, t])

  const errorStyle: CSSProperties | undefined =
    !canChangeToQuoteState && !canChangeToNegotiatingState
      ? {
          cursor: 'not-allowed',
        }
      : undefined

  return {
    canChangeToNegotiatingState,
    canChangeToQuoteState,
    Errors,
    errorStyle,
    errorCount,
    currentProjectStatus,
    imnooUnresolvedCount,
  }
}
